import * as React from "react";
import { useCallback, useMemo } from "react";
import { Formik, Form } from "formik";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import { Modal } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import ModalSubmit from "components/common/ModalSubmit";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { updateWidget } from "views/logic/slices/widgetActions";
import SaveContextInfo from "ai/common/SaveContextInfo";
import AppConfig from "util/AppConfig";
const AddContextActionComponent = ({ onClose, widget }) => {
  const dispatch = useViewsDispatch();
  const initialValues = useMemo(() => ({ context: widget == null ? void 0 : widget.context }), [widget == null ? void 0 : widget.context]);
  const onSubmit = useCallback(
    async ({ context }) => {
      const updatedWidget = widget.toBuilder().context(context).build();
      await dispatch(updateWidget(widget.id, updatedWidget));
      onClose();
    },
    [dispatch, onClose, widget]
  );
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add/Edit Context")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("p", null, "Adding context clarifies your widget's purpose and helps users understand how to interpret its results. This also ensures the AI widget summary is generated with the most accurate and insightful analysis."), /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit }, /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      "data-autofocus": true,
      autoFocus: true,
      label: "Context",
      name: "context",
      type: "textarea",
      id: "context",
      rows: 12
    }
  ), /* @__PURE__ */ React.createElement(SaveContextInfo, null), /* @__PURE__ */ React.createElement(ModalSubmit, { submitButtonText: "Update", onCancel: onClose })))));
};
const AddContextAction = {
  type: "add-context-action",
  position: "dropdown",
  component: AddContextActionComponent,
  title: () => /* @__PURE__ */ React.createElement(React.Fragment, null, "Add/Edit Context"),
  isHidden: ({ type }) => {
    var _a, _b, _c, _d, _e;
    return ((_e = (_d = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.features) == null ? void 0 : _d.widget_summary) == null ? void 0 : _e.enabled) === false || type !== AggregationWidget.type;
  }
};
export default AddContextAction;
